export default "__VITE_ASSET__Dmt3xw9n__"